/**
 * `/` — GAMES NIGHT HOME (FIRST NIGHT S1). Copy VERBATIM from the brief.
 * Skeleton→content via SkeletonToContent (KICKOFF §3.3 — loading is the
 * entrance). No real night config exists yet: the loader is an honest stub
 * seam (Loop 1/2 wires tonight's config); the hero slot self-announces per
 * KIT CHECK Rule 1.
 *
 * The volt CTA is the screen's ONE attractor (single attractor law).
 */
import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { SkeletonToContent, Skeleton } from "@matchday/ui";
import { BreathingAttractor } from "@matchday/juice";
import { CodeBoxes } from "../components/CodeBoxes";
import { auth } from "../lib/platform";
import { NIGHT_CODE_KEY } from "../lib/matchApi";

/** LOOP 1 SEAM: replace with the real night-config fetch (nights table). */
function loadNightConfig(): Promise<null> {
  return Promise.resolve(null);
}

export default function Landing() {
  const [loading, setLoading] = useState(true);
  const [nightCode, setNightCode] = useState<string | null>(null);
  const [, navigate] = useLocation();

  /** CTA: session exists → straight into /feed; else /auth (then back). */
  const enter = async () => {
    if (nightCode !== null) {
      try {
        sessionStorage.setItem(NIGHT_CODE_KEY, `BLG-${nightCode}`);
      } catch {
        // private mode — the wizard's no_night guard covers it
      }
    }
    const session = await auth.getSession();
    navigate(session !== null ? "/feed" : "/auth");
  };

  useEffect(() => {
    let alive = true;
    void loadNightConfig().then(() => {
      if (alive) setLoading(false);
    });
    return () => {
      alive = false;
    };
  }, []);

  return (
    <SkeletonToContent
      loading={loading}
      skeleton={
        <div className="pl-landing">
          <Skeleton variant="panel" clip="notch-12" aspect={394 / 220} />
          <Skeleton variant="text-line" width="70%" />
          <Skeleton variant="text-line" width="90%" />
          <Skeleton variant="card" height={96} />
        </div>
      }
    >
      <main className="pl-landing">
        {/* Biggie hero render slot, 394×220 (FIRST NIGHT A1). KIT CHECK Rule 1:
            placeholders self-announce — volt dashed outline + slot label. */}
        <div className="pl-awaiting pl-landing-hero" aria-label="Biggie hero render slot">
          <span className="pl-awaiting-label">BIGGIE HERO RENDER · 394×220</span>
          <span className="pl-awaiting-tag">AWAITING: A1_BIGGIE_HERO</span>
        </div>

        <p className="pl-eyebrow">GAMES NIGHT · LIVE</p>
        <h1 className="pl-h1">WELCOME TO GAMES NIGHT</h1>
        <p className="pl-sub">EA FC fans from across the country. One arena. Every night.</p>
        <p className="pl-line2">
          Challenge your host BIGGIE. Play, win, claim prizes — just for pulling up.
        </p>
        <p className="pl-tag">Your nightly gaming fix starts now.</p>

        <div className="pl-codefield">
          <label className="pl-codefield-label">ENTER CODE TO JOIN</label>
          <CodeBoxes
            length={4}
            charset="alnum"
            prefix="BLG-"
            label="Night code"
            onComplete={setNightCode}
          />
        </div>

        <BreathingAttractor name="landing-cta" className="pl-cta-slot">
          {/* LOOP 1 SEAM: code validation ceremony (MATCH POINT §7) still
              pending — the CTA now routes by session: stored session → the
              feed; none → OTP. The entered code is stashed for the wizard. */}
          <button type="button" className="pl-cta" onClick={() => void enter()}>
            JOIN GAMES NIGHT
          </button>
        </BreathingAttractor>
      </main>
    </SkeletonToContent>
  );
}
